import React from 'react'

const PreferenceContext = React.createContext({
  isListLayout: false
})

export const PreferenceProvider = PreferenceContext.Provider
export const PreferenceConsumer = PreferenceContext.Consumer

export default PreferenceContext
